import { Component, EventEmitter, Input, Output, ViewChild } from "@angular/core";
import { TabData } from "../..";
import { CheckUtils } from "../../ui-utils/check-utils";
var HTML_TEMPLATE = "\n<div #odTab class=\"od-tab\" (mouseover)=\"displayButtons()\">\n\t<div class=\"od-tab-previous odi_breadcrumbsArrowLeft\" (click)=\"onClickOnPrevious(e)\"></div>\n\t<div #odTabPanel class=\"od-tab-panel\">\n\t\t<ion-list *ngIf=\"_datas !=null\" class=\"od-tab-list\" [ngStyle]=\"{'min-width': 'calc(' + _maxContentSize + 'px * ' + _datas.length + ')'}\" >\n\t\t\t<od-button *ngFor=\"let _data of _datas\"  class=\"od-tab-list-button\" \n\t\t\t\t [text]=\"_data.name\" size=\"150px\" \n\t             [active]=\"active == _data\"\n\t             (click)=\"onSelect(_data)\"></od-button>\n\t    </ion-list>\n    </div>\n    <div class=\"od-tab-next odi_breadcrumbsArrowRight\" (click)=\"onClickOnNext(e)\"></div>\n</div>\n";
var CSS_STYLE = "\n.od-tab{\n\tposition:relative;\n}\n\n.od-tab-panel{\n\tposition:relative;\n\toverflow:hidden;\n}\n\n.od-tab-list{\n    display: -webkit-box;\n    display: -webkit-flex;\n    display: -ms-flexbox;\n    display: flex;\n    -webkit-box-orient: horizontal;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: row;\n    -ms-flex-direction: row;\n    flex-direction: row;\n    -webkit-box-pack: center;\n    -webkit-justify-content: center;\n    -ms-flex-pack: center;\n    justify-content: center;\n    -webkit-box-align: center;\n    -webkit-align-items: center;\n    -ms-flex-align: center;\n    align-items: center;\n}\n\n.od-tab-list-button {\n\twidth: 100% !important;\n\tcursor: pointer;\n}\n\n.od-tab-previous,\n.od-tab-next{\n\theight: 100%;\n    width: 26px;\n    background-color: rgba(0,0,0,0.3);\n    top: 0;\n    position: absolute;\n    cursor: pointer;\n    display:none;\n    z-index:100;\n}\n\n.od-tab .od-tab-previous:before,\n.od-tab .od-tab-next:before{\n\tcolor:white;\n}\n\n.od-tab-scroll-previous.od-tab:hover .od-tab-previous,\n.od-tab-scroll-next.od-tab:hover .od-tab-next{\n\tdisplay: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.od-tab-next{\n\tright: 0;\n}\n\n.od-tab-previous{\n    left: 0;\n}\n\n@media screen and (max-width: 400px){\n\t.od-tab-list{\n\t\tmin-width: fit-content !important;\n\t}\n}\n";
var Tabs = /** @class */ (function () {
    function Tabs() {
        this.select = new EventEmitter();
        this.clickOnPrevious = new EventEmitter();
        this.clickOnNext = new EventEmitter();
        this._maxContentSize = 150;
    }
    Object.defineProperty(Tabs.prototype, "datas", {
        get: function () {
            return this._datas;
        },
        set: function (values) {
            var _this = this;
            this._datas = [];
            if (!CheckUtils.isEmpty(values)) {
                values.forEach(function (v) {
                    if (v.activated == true)
                        _this._datas.push(v);
                });
                this._datas.sort(function (o1, o2) {
                    if (o1.position == null) {
                        return -1;
                    }
                    else if (o2.position == null) {
                        return 1;
                    }
                    else if (o1.position < o2.position) {
                        return -1;
                    }
                    else if (o1.position > o2.position) {
                        return 1;
                    }
                    return 0;
                });
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(Tabs.prototype, "maxContentSize", {
        get: function () {
            return this._maxContentSize;
        },
        set: function (value) {
            if (value != null && value > -1)
                this._maxContentSize = value;
        },
        enumerable: true,
        configurable: true
    });
    Tabs.prototype.displayButtons = function () {
        if (this.odTab.nativeElement.clientWidth < this.odTabPanel.nativeElement.scrollWidth) {
            if (this.odTabPanel.nativeElement.scrollLeft > 2) {
                this.odTab.nativeElement.classList.add("od-tab-scroll-previous");
            }
            else {
                this.odTab.nativeElement.classList.remove("od-tab-scroll-previous");
            }
            if (this.odTabPanel.nativeElement.scrollLeft + this.odTabPanel.nativeElement.clientWidth + 2 < this.odTabPanel.nativeElement.scrollWidth) {
                this.odTab.nativeElement.classList.add("od-tab-scroll-next");
            }
            else {
                this.odTab.nativeElement.classList.remove("od-tab-scroll-next");
            }
        }
        else {
            this.odTab.nativeElement.classList.remove("od-tab-scroll-previous");
            this.odTab.nativeElement.classList.remove("od-tab-scroll-next");
        }
    };
    Object.defineProperty(Tabs.prototype, "scrollTo", {
        set: function (value) {
            var _this = this;
            if (value < 0)
                value = 0;
            if (this.odTabPanel != null) {
                if (value > this.odTabPanel.nativeElement.scrollWidth)
                    value = this.odTabPanel.nativeElement.scrollWidth;
                this.odTabPanel.nativeElement.scrollTo({
                    top: 0,
                    left: value,
                    behavior: "smooth"
                });
            }
            setTimeout(function () { return _this.displayButtons(); }, 800);
        },
        enumerable: true,
        configurable: true
    });
    Tabs.prototype.onSelect = function (value) {
        if (this.select != null)
            this.select.emit(value);
    };
    Tabs.prototype.onClickOnPrevious = function (value) {
        if (this.clickOnPrevious != null && this.odTabPanel != null)
            this.clickOnPrevious.emit(this.odTabPanel.nativeElement.scrollLeft);
    };
    Tabs.prototype.onClickOnNext = function (value) {
        if (this.clickOnNext != null && this.odTabPanel != null)
            this.clickOnNext.emit(this.odTabPanel.nativeElement.scrollLeft);
    };
    Tabs.decorators = [
        { type: Component, args: [{
                    selector: "od-tabs",
                    template: HTML_TEMPLATE,
                    styles: [CSS_STYLE]
                },] },
    ];
    /** @nocollapse */
    Tabs.ctorParameters = function () { return []; };
    Tabs.propDecorators = {
        "active": [{ type: Input },],
        "odTab": [{ type: ViewChild, args: ["odTab",] },],
        "odTabPanel": [{ type: ViewChild, args: ["odTabPanel",] },],
        "select": [{ type: Output },],
        "clickOnPrevious": [{ type: Output },],
        "clickOnNext": [{ type: Output },],
        "maxContentSize": [{ type: Input },],
        "datas": [{ type: Input },],
        "scrollTo": [{ type: Input },],
    };
    return Tabs;
}());
export { Tabs };
//# sourceMappingURL=tabs.js.map


//////////////////
// WEBPACK FOOTER
// /home/qa/builder/ui-ts/dist/ui-components/tabs/tabs.js
// module id = 453
// module chunks = 14